// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import App from './App'
import Raven from 'raven-js'

// import Graph from 'components/Graph'
// import Render from 'components/Render'

import Home from './screens/Home'
import Form from './screens/Form'
import Summary from './screens/Summary'
import Review from './screens/Review'
import ReviewConfirm from './screens/ReviewConfirm'

import Checkout from './screens/Checkout'
import CheckoutForm from './screens/CheckoutForm'
import CheckoutPreview from './screens/CheckoutPreview'
import CheckoutPayment from './screens/CheckoutPayment'
import CheckoutPaymentWhy from './screens/CheckoutPaymentWhy'
import CheckoutPaypal from './screens/CheckoutPaypal'

import CheckoutStripe from './screens/CheckoutStripe'
import CheckoutStripeFriend from './screens/CheckoutStripeFriend'
import CheckoutMandatExpress from './screens/CheckoutMandatExpress'
import CheckoutWesternUnion from './screens/CheckoutWesternUnion'
// import CheckoutWire from './screens/CheckoutWire'

import ScreenAdmin from './screens/ScreenAdmin'
import ScreenRefused from './screens/ScreenRefused'
import ScreenDemandeVisa from './screens/ScreenDemandeVisa'
import ScreenAvocat from './screens/ScreenAvocat'
import ScreenWeContactYou from './screens/ScreenWeContactYou'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'


// import ServiceAccess from './service/ServiceAccess'



/*eslint no-undef: "off"*/
console.log('App Version: ' + __VERSION__)
console.log('Process Env: ' + JSON.stringify(process.env))
if (process.env && process.env['NODE_ENV'] !== 'development') {
  console.log('Raven Setup')
  Raven.config('https://6d3ca8cfaac64042b454b96154128ba5@sentry.io/121211').install()
}


Vue.use(VueMaterial)
Vue.use(VueResource)
Vue.use(VueRouter)

Vue.material.theme.register('default', {
  primary: 'blue',
  accent: 'blue',
  background: 'grey',
  warn: 'deep-orange'
})


function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

const redirectNewSession = to => {
  let newSession =  guid()
  // ServiceAccess.instance.track(newSession, 'new-session')
  return '/f/' + newSession
}
const redirectOQTF = to => {
  if (process.env && process.env['NODE_ENV'] !== 'development') {
    window.location.href = 'https://app.refusdetitredesejour.fr/f/' + to.params.sessionId + '/start'
  } else {
    window.location.href = 'https://staging.app.refusdetitredesejour.fr/f/' + to.params.sessionId + '/start'
  }
  return '/f/' + to.params.sessionId + '/start'
}

const routes = [
  // { path: '/graph', component: Graph },
  // { path: '/render/:sessionId', component: Render }

  { path: '/', redirect: redirectNewSession },
  { path: '/f', redirect: redirectNewSession },

  { name: 'checkout-stripe-cypher', path: '/p/:sessionId', component: CheckoutStripe },

  { name: 'home', path: '/f/:sessionId', component: Home },

  { name: 'checkout', path: '/f/:sessionId/checkout', component: Checkout },
  { name: 'checkout-form', path: '/f/:sessionId/checkoutform/:cart', component: CheckoutForm },
  { name: 'checkout-preview', path: '/f/:sessionId/preview/:cart', component: CheckoutPreview },
  { name: 'checkout-pay', path: '/f/:sessionId/payment/:cart', component: CheckoutPayment },
  { name: 'checkout-why', path: '/f/:sessionId/payment-why/:medium/:cart', component: CheckoutPaymentWhy },
  

  { name: 'checkout-stripe', path: '/f/:sessionId/stripe/:cart', component: CheckoutStripe },
  { name: 'checkout-stripe-friend', path: '/f/:sessionId/stripe-friend/:cart', component: CheckoutStripeFriend },
  { name: 'checkout-mandat', path: '/f/:sessionId/mandat-express/:cart', component: CheckoutMandatExpress },
  { name: 'checkout-western', path: '/f/:sessionId/western-union/:cart', component: CheckoutWesternUnion },
  // { name: 'checkout-wire', path: '/f/:sessionId/wire/:cart', component: CheckoutWire },
  { name: 'checkout-paypal', path: '/f/:sessionId/paypal/:cart', component: CheckoutPaypal },

  { path: '/f/:sessionId/admin', component: ScreenAdmin },

  { path: '/f/:sessionId/ko', component: ScreenRefused },
  { path: '/f/:sessionId/oqtf', redirect: redirectOQTF },

  { path: '/f/:sessionId/demande%20visa', component: ScreenDemandeVisa },
  { path: '/f/:sessionId/demande visa', component: ScreenDemandeVisa },

  { path: '/f/:sessionId/contact%20avocat', component: ScreenAvocat },
  { path: '/f/:sessionId/contact avocat', component: ScreenAvocat },

  { path: '/f/:sessionId/wecontact', component: ScreenWeContactYou },

  { path: '/f/:sessionId/parcours%20gracieux', component: ScreenAvocat },
  { path: '/f/:sessionId/parcours gracieux', component: ScreenAvocat },

  { path: '/f/:sessionId/summary', component: Summary },

  { path: '/f/:sessionId/:screenId', component: Form },
  { path: '/s/:sessionId', component: Summary },

  { path: '/review/:sessionId/:sign', component: Review },
  { path: '/confirm/:sessionId/:sign/:filename', component: ReviewConfirm }



]



const router = new VueRouter({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (window.ga) {
    let sessionId = to.params.sessionId
    let path = to.path.substring(to.path.indexOf(sessionId) + sessionId.length)
    window.ga('send', 'pageview', '/app' + path)
  }
  next(true)
})

global.navigationBarBus = new Vue()

new Vue({
  router,
  ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js